<div class="price-container" [class]="size">
  <span class="price-currency display-xsmall">{{ price.currency }}</span>
  <span class="price-amount display-xsmall">
    <h1>{{ price.amount | number: '1.' + format | slice: 0 : precision === 0 ? undefined : -3 }}</h1>
    <span *ngIf="precision !== 0" class="price-decimal h1-page-heading" [class]="">{{ price.amount | number: '1.' + format | slice: -3 }}</span>
  </span>
  <span *ngIf="price.frequency" class="price-frequency display-xsmall">/{{ price.frequency }}</span>
</div>
